(function(){
	/**
	 * variable
	 *
	*/
	const activeClass = 'is-active',
		  otherClass = 'is-other',
		  scrolledClass = "is-scrolled",
		  breakpointMd = 768,
		  mqMd = window.matchMedia('(min-width:'+ breakpointMd +'px)');

	// ブラウザがIE11かどうかのフラグ
	const userAgent = window.navigator.userAgent.toUpperCase();
	const ieFlag = userAgent.indexOf('MSIE') === -1 && userAgent.indexOf('TRIDENT') === -1 ?
				   false :
				   true ;
	/**
	 * Event
	 *
	*/
	//ready
	window.addEventListener("DOMContentLoaded", function(){
		//headerインタラクシzョン
		header();
		//クリックしたらactive class
		toggle();
		//リンク有効/無効切り替え
		responsiveLink();
		//リサイズ中のtransition停止
		stopResponsiveTransition();
		//フッターのあコーディン処理
		footerAccordion();
		//遠隔のタブ処理
		ajiHistoryTab();
		modalUI();
		modalClose();
		modalOpen();
		gnavNew();
	});

	//load
	window.addEventListener('load', function() {
		//スライダー
		slider();
		storiesArchiveLayout();
		//アコーディオン
		accordion();
		//スムーススクロール
		smoothScroll();
	},false);

	//リサイズ時に実行
	var _resizeEvent;
	window.addEventListener('resize',function(){
		clearTimeout(_resizeEvent);
		_resizeEvent = setTimeout(function(){
			fixedHeader();
			storiesArchiveLayout();
			footerResponsive();
			modalUI();
		} , 100);
	});

	//スクロール時に実行
	window.addEventListener( 'scroll' , () => {
		fixedHeader();
		scrollUpHeader();
	});

	/**
	 * function
	 *
	*/
	//headerインタラクション
	function header(){
		menu();
		submenu();
		back();
		searchToggle();
		fixedHeader();
		scrollUpHeader();
		utilitylangLs();
	}

	/**
	 * ヘッダーの高さ分だけスクロールしたら
	 * ナビゲーションの位置を固定化する処理
	 */
	const fixedHeader = () => {
		let headerHeight = document.querySelector(".header").offsetHeight;
		let scrollPosition = document.documentElement.scrollTop || document.body.scrollTop;
		let $headerFixes = document.querySelectorAll(".header , .l-gnav");
		let $headerSearches = document.querySelectorAll(".header-search , .js-search");
		$headerFixes = Array.prototype.slice.call( $headerFixes,0);
		$headerSearches = Array.prototype.slice.call( $headerSearches,0);
		if( scrollPosition >= headerHeight) {
			$headerFixes.forEach($headerFix =>{
				$headerFix.classList.add(scrolledClass);
			})
			$headerSearches.forEach($headerSearch => {
				$headerSearch.classList.remove(activeClass);
			});
		} else {
			$headerFixes.forEach($headerFix => {
				$headerFix.classList.remove(scrolledClass);
			});
		}
	}

	/**
	 * 上方向にスクロールした場合のみ、
	 * グローバルナビゲーションを表示する処理
	 */

	//スクロール位置を初期化
	let startPosition = 0;
	const scrollUpHeader = () => {
		if(!ieFlag) {
			//ヘッダーの高さを取得
			let headerHeight = document.querySelector(".header").offsetHeight;

			//現在のスクロール位置を取得
			let scrollPosition = document.documentElement.scrollTop || document.body.scrollTop;

			//固定化する要素の取得
			let $headerFixes = document.querySelectorAll(".header , .l-gnav-new");
			let $headerSearches = document.querySelectorAll(".header-search , .js-search");
			$headerFixes = Array.prototype.slice.call( $headerFixes , 0 );
			$headerSearches = Array.prototype.slice.call( $headerSearches , 0 );
			if ( scrollPosition > headerHeight) {
				$headerFixes.forEach($headerFix => {
					$headerFix.classList.add("is-fixed");
				});
				$headerSearches.forEach($headerSearch => {
					$headerSearch.classList.remove("is-fixed");
				});
				if(startPosition > scrollPosition) {
					$headerFixes.forEach($headerFix => {
						$headerFix.classList.add("is-scroll-to-upper");
					});
				} else {
					$headerFixes.forEach($headerFix => {
						$headerFix.classList.remove("is-scroll-to-upper");
					});
				}
			} else {
				$headerFixes.forEach($headerFix => {
					$headerFix.classList.remove("is-fixed");
					$headerFix.classList.remove("is-scroll-to-upper");
				});
			}
			startPosition = scrollPosition;
		}
	}

	/**
	 * 2022年リニューアル版のグローバルナビゲーションの動作
	 */
	const gnavNew = () => {

		//グローバルナビゲーションのタブボタン
		const tabBtns = document.getElementsByClassName( 'l-gnav-new-tab__list__item' );
		const $tabBtns = Array.from(tabBtns);

		//タブボタン配下のタブコンテンツ
		const $mainContent = document.getElementsByClassName( 'l-gnav-new-contents').item(0);

		//タブコンテンツのメインメニュー
		const navContents = document.getElementsByClassName( 'l-gnav-new-contents__main' );
		const $navContents = Array.from(navContents);

		//タブコンテンツのメインメニュー内のボタン
		const mainContentBtns = document.querySelectorAll( 'button.l-gnav-new-contents__main__list__item');
		const $mainContentBtns = Array.from(mainContentBtns);

		//タブコンテンツのサブメニュー
		const subContents = document.getElementsByClassName( 'l-gnav-new-contents__sub-wrapper' );
		const $subContents = Array.from(subContents);

		//サブメニュー閉じるボタン
		const subMenuCloseBtons = document.getElementsByClassName( 'l-gnav-new-contents__sub-close');
		const $subMenuCloseBtons = Array.from(subMenuCloseBtons);

		//サブメニューバックボタン（スマホ・タブレット用）
		const $menuBackBtn = document.getElementsByClassName("l-gnav-new-control__back").item(0);


		//タブ切り替えの処理
		$tabBtns.forEach($tabBtn => {
			$tabBtn.addEventListener("click" , e =>{
				$tabBtns.forEach($tabBtn => {
					$tabBtn.classList.remove("is-active");
					$tabBtn.classList.remove("is-active-previous");
					$tabBtn.classList.remove("is-active-sp");
				});
				const dataID = e.currentTarget.getAttribute('data-id');
				$menuBackBtn.classList.add("is-active-sp");

				if(!e.currentTarget.classList.contains("is-active")) {
					if(e.currentTarget.previousElementSibling) {
						e.currentTarget.previousElementSibling.classList.add("is-active-previous");
					}
					e.currentTarget.classList.add("is-active");
				}
				if(!e.currentTarget.classList.contains("is-active-sp")) {
					e.currentTarget.classList.add("is-active-sp");
				}

				$mainContent.classList.toggle("is-active-sp");

				$navContents.forEach($navContent => {
					$navContent.classList.remove("is-active");
					$navContent.classList.remove("is-active-sp");
				} );
				document.getElementById(dataID).classList.add("is-active");
				document.getElementById(dataID).classList.add("is-active-sp");
			});
		});

		//サブナビゲーションの開閉処理
		$mainContentBtns.forEach($mainContentBtn => {
			$mainContentBtn.addEventListener("click" , e => {
				$mainContentBtns.forEach($btn => {
					$btn.classList.remove("is-active");
					$btn.classList.remove("is-active-sp");
				});
				e.currentTarget.classList.add("is-active");
				const $subTargetContent = e.currentTarget.nextElementSibling;
				if(!$subTargetContent.classList.contains("is-active")) {
					$subContents.forEach($subContent =>{
						$subContent.classList.remove("is-active");
					});
					$subTargetContent.classList.add("is-active");
				} else {
					e.currentTarget.classList.remove("is-active");
					$subTargetContent.classList.remove("is-active")
					$subTargetContent.classList.remove("is-active-sp");
				}
				$subTargetContent.classList.add("is-active-sp");
			});
		});

		//サブメニュー閉じるボタン
		$subMenuCloseBtons.forEach($subMenuCloseBton => {
			$subMenuCloseBton.addEventListener("click", e => {
				e.currentTarget.parentNode.classList.remove("is-active");
				e.currentTarget.parentNode.previousElementSibling.classList.remove("is-active");
			})
		});

		/**
		 * タブレット・スマートフォン
		 */
		const $menuBtn = document.querySelector('.js-menu');
		const $gnaNew = document.querySelector(".l-gnav-new");

		const $gnavCloseBtn = document.querySelector('.l-gnav-new-control__close');

		//メニュー開く
		$menuBtn.addEventListener("click", e => {
			$gnaNew.classList.toggle("is-active-sp");
		});

		//メニュー閉じる
		$gnavCloseBtn.addEventListener("click", e => {
			const $gnavActiveItems = document.querySelectorAll(".is-active-sp");
			$gnavActiveItems.forEach($gnavActiveItem =>{
				$gnavActiveItem.classList.remove("is-active-sp");
			});
		});

		//Backボタンの動作処理
		$menuBackBtn.addEventListener("click" , e => {
			if( document.querySelector(".l-gnav-new-contents__sub-wrapper.is-active-sp") ) {
				$subContents.forEach($subContent => {
					$subContent.classList.remove("is-active-sp");
				});
			} else if ( document.querySelector(".l-gnav-new-contents__main.is-active-sp") ) {
				$navContents.forEach($navContent => {
					$navContent.classList.remove("is-active-sp");
				});
				$mainContent.classList.remove("is-active-sp");
				$menuBackBtn.classList.remove("is-active-sp");
			}
		});

	}


	/**
	 * モーダルUI
	 */
	const modalOpen = () => {
		$(".js-modal").on( "click" , function() {
			$('.'+ $(this).attr('id')).addClass("is-active");
			modalUI();
		})
	}
	const modalClose = () => {
		$(".p-modal__content__close").on("click keypress" , function() {
			$(this).parents(".p-modal").fadeOut(500).removeClass("is-active");
		});
	}
	const modalUI = () => {
		let windowWidth = window.innerWidth;
		let windowHeight = window.innerHeight;
		$(".p-modal.is-active").css(
			{
				"width" : windowWidth,
				"height" : windowHeight
			}
		);
		$(".p-modal.is-active").find(".p-modal__content").css(
			{
				"width" : windowWidth * 0.9,
				"height" : windowHeight * 0.9,
			}
		);
		$(".p-modal.is-active").fadeIn(500,function(){
			var n = 1;
			setTimeout(function(){
				let closePositionX = $(".p-modal.is-active .p-modal__content__item").width() * 0.5 - 12;
				let closePositionY = $(".p-modal.is-active .p-modal__content__item").height() * 0.5 - 12;
				$(".p-modal.is-active .p-modal__content__close").css('transform', 'translateX(' + closePositionX + 'px)' + 'translateY(' + -closePositionY + 'px)');
				$(".p-modal.is-active .p-modal__content__close").fadeIn();
				$(".p-modal__content__close").each(function(){
					$(this).attr("tabindex",n++);
				})
			},100)
		})
	}

	//Menuボタン
	function menu(){
		const $menu = $('.js-menu');
		//メニュー開閉
		$menu.on('click', event => {
			event.preventDefault();
			const $this = $(event.currentTarget);
			const $target = $('.l-gnav');
			const $targetMenu = $('.l-gnav__menu');
			const $targetBack = $('.l-gnav__back');
			const $accordion = $('.js-accordion');
			$(".header-langs__list").css("display","");
			$(".header-langs__current").removeClass("is-active");
			$this.toggleClass(activeClass);
			$target.toggleClass(activeClass);
			if(!$this.hasClass(activeClass)){
				$target.find('.l-gnav__submenu').removeAttr('style');
				$targetMenu.find('.' + activeClass).removeClass(activeClass);
				$targetBack.removeClass(activeClass);
				$accordion.removeClass(activeClass);
				$target.addClass("is-close");
			} else {
				$target.removeClass("is-close");
			}
		});
	}

	//Sub Menu
	function submenu(){
		//メニュー開閉
		const $submenu = $('.js-submenu');
		const $submenuBottom = $('.js-submenu-bottom');

		//第3階層の開閉
		$submenu.on('click', event => {
			event.preventDefault();
			const $this = $(event.currentTarget);
			const $window = $(window);
			const target = '.l-gnav__submenu';
			const targetHeight = $this.next(target).height();
			const targetPadding = 44;
			const submenuHeight = targetHeight + targetPadding * 2;
			const $targetSubmenu = $this.closest('.l-gnav__menu-item').children(target);
			$this.next(target).find($submenuBottom).removeClass(activeClass);
			if($window.width() < breakpointMd){
				$targetSubmenu.removeAttr('style');
			} else {
				if($this.hasClass(activeClass)){
					$targetSubmenu.css({
						'min-height': '0'
					});
				} else {
					$targetSubmenu.css({
						'min-height': submenuHeight
					});
				}
			}
		});

		//第4階層の開閉
		$submenuBottom.on('click', event => {
			event.preventDefault();
			const $this = $(event.currentTarget);
			const $window = $(window);
			const target = '.l-gnav__submenu';
			const targetHeight = $this.next(target).height();
			const thisHeight = $this.parents(target).height();
			const targetPadding = 44;
			const submenuHeightBottom = targetHeight + targetPadding * 2;
			const thisHeightPadding = thisHeight  + targetPadding * 2;
			const $targetSubmenu = $this.closest('.l-gnav__menu-item').children(target);
			if($window.width() < breakpointMd){
				$targetSubmenu.removeAttr('style');
			} else {
				if(!$this.hasClass(activeClass)){
					if(thisHeightPadding < submenuHeightBottom ) {
						$targetSubmenu.css({
							'min-height': submenuHeightBottom
						});
					} else {
						$targetSubmenu.css({
							'min-height': thisHeightPadding
						});
					}
				} else {
					$targetSubmenu.css({
						'min-height': thisHeightPadding
					});
				}
			}
		});
		//閉じるボタン
		const $submenuClose = $('.js-submenu-close');
		$submenuClose.on('click', event => {
			event.preventDefault();
			const $this = $(event.currentTarget);
			// data-idの指定先idをクリック
			const targetId = $this.attr('data-id');
			$('#' + targetId).click();
			$('.l-gnav__submenu-link').removeClass(activeClass+' '+otherClass);
		});
	}

	//Backボタン
	function back(){
		const $back = $('.js-back');
		const $headerMenu = $('.l-gnav__menu');
		const $headerMenuLink = $('.l-gnav__menu-link.js-accordion , .header__info-link.js-accordion');
		//スライドイン
		$headerMenuLink.on('click', event => {
			if($headerMenu.find('.' + activeClass).length) {
				$back.removeClass(activeClass);
			} else {
				$back.addClass(activeClass);
			}
		});
		//前のメニューに戻る
		$back.on('click', event => {
			event.preventDefault();
			const $this = $(event.currentTarget);
			const $target = $('.header,.header__trigger');
			const $targetMenu = $('.l-gnav__menu-link ,.header__info-link');
			const $targetSubMenu = $('.l-gnav__submenu-link');
			const $targetSubMenuChild = $('.l-gnav__submenu .l-gnav__submenu .l-gnav__submenu-link');
			if($targetSubMenuChild.hasClass(activeClass)){
				$targetSubMenuChild.removeClass(activeClass);
			} else if($targetSubMenu.hasClass(activeClass)){
				$targetSubMenu.removeClass(activeClass);
			} else if($targetMenu.hasClass(activeClass)){
				$this.removeClass(activeClass);
				$targetMenu.removeClass(activeClass);
			} else {
				$target.removeClass(activeClass);
			}
		});
	}

	//Searchボタン
	const searchToggle = () => {
		const $search = document.querySelector(".js-search");
		const $target = document.querySelector(".header-search");
		$search.addEventListener('click', e => {
			const $this = e.currentTarget;
			if($this.classList.contains("is-active")) {
				$this.classList.remove("is-active");
				$target.classList.remove("is-active");
			} else {
				$this.classList.add("is-active");
				$target.classList.add("is-active");
			}

			// $target.toggleClass(activeClass);
			// $this.toggleClass(activeClass);
			// if($this.hasClass(activeClass)){
			// 	$target.slideDown("fast");
			// 	$targetInput.focus().prop('tabIndex', false);
			// 	$targetButton.prop('tabIndex', false);
			// } else {
			// 	$target.slideUp("fast");
			// 	$targetInput.blur().prop('tabIndex', '-1');
			// 	$targetButton.prop('tabIndex', '-1');
			// }
		});
	}

	//言語セレクトボタンの開閉処理
	const utilitylangLs = () => {
		const $currentLang = $(".header-langs__current");
		$currentLang.on("click" , event => {
			const currentLangHeight = $currentLang.outerHeight();
			const $this = $(event.currentTarget);
			if($this.hasClass("is-active")) {
				$this.removeClass("is-active");
				$this.next().slideUp();
			} else {
				$this.addClass("is-active");
				$this.next().css('top', currentLangHeight).slideToggle();
			}
		});
	}

	//クリックしたらactive class
	function toggle(){
		const $toggle = $('.js-toggle');
		$toggle.on('click', event => {
			event.preventDefault();
			const $this = $(event.currentTarget);
			// data-idの指定先idをクリック
			const targetId = $this.attr('data-id');
			if(targetId){
				$('#' + targetId).click();
			}
			// data-classの指定先classにactive
			const targetClass = $this.attr('data-class');
			if(targetClass){
				$('.' + targetClass).toggleClass(activeClass);
			}
			// data-groupが指定されていたらグループ化
			const group = $this.attr('data-group');
			if(group){
				if($this.hasClass(activeClass)){
					$this.removeClass(activeClass);
					$('[data-group="'+group+'"]').removeClass(otherClass);
				} else {
					$('[data-group="'+group+'"]').removeClass(activeClass);
					$('[data-group="'+group+'"]').addClass(otherClass);
					$this.removeClass(otherClass);
					$this.addClass(activeClass);
				}
			} else {
				// クリックする度にclassを付与/除去
				$this.toggleClass(activeClass);
			}
		});
	}

	//アコーディオン
	function accordion() {
		const $window = $(window);
		const $accordion = $('.js-accordion');
		const $submenu = $(".js-submenu");
		const $submenuBottom = $(".js-submenu-bottom");
		const speed = 400; // 開閉スピード
		function responsiveAccordion() {
			$accordion.each((index, element) => {
				const $this = $(element);
				const $target = $this.next();
				const targetHeight = $target.children().outerHeight();
				if($this.hasClass(activeClass)) {
					$target.css('max-height',targetHeight);
				}
			});
		}
		responsiveAccordion();
		$window.on('resize',() => {
			responsiveAccordion();
		});
		$accordion.on('click', event => {
			//メインナビをクリックするとサブナビを非表示にする処理
			$submenu.removeClass(activeClass);
			$submenuBottom.removeClass(activeClass);

			$("#global-navi").find("js-active");
			const $this = $(event.currentTarget);
			const $target = $this.next();
			const targetHeight = $target.children().outerHeight();
			// デフォルトの挙動を無効化
			if($this.filter('a,button').length){
				event.preventDefault();
			}
			// data-accordionが指定されていたらグループ化
			const group = $this.attr('data-group');
			if(group){
				if($this.hasClass(activeClass)){
					$this.removeClass(activeClass);
					$target.removeAttr('style');
					$('[data-group="'+group+'"]').removeClass(otherClass);
				} else {
					$('[data-group="'+group+'"]').removeClass(activeClass).next().removeAttr('style');
					$this.addClass(activeClass);
					$target.css('max-height',targetHeight);
					$('[data-group="'+group+'"]').addClass(otherClass);
					$this.removeClass(otherClass);
				}
			} else {
				// クリックする度にclassを付与/除去
				$this.toggleClass(activeClass);
				// 次の要素にmax-heightを与える
				if($this.hasClass(activeClass)) {
					$target.css('max-height',targetHeight);
				} else {
					$target.removeAttr('style');
				}
			}
		});
	}

	//スムーススクロール
	const smoothScroll = () => {
		const $scroll = $('a[href^="#"]:not([href="#"])');
		const speed = 400;
		const urlHash = location.hash;
		let headerHeight = 0;
		//URLにハッシュが存在する場合の処理
		if(urlHash) {
			$('body,html').stop().scrollTop(0);
			setTimeout(() => {
				//旧タイプのグローバルナビゲーションに対応
				if( document.querySelector(".l-gnav") ) {
					if(window.innerWidth > 1024 && document.querySelector(".l-gnav").classList.contains("is-scrolled")) {
						headerHeight = document.querySelector(".l-gnav").offsetHeight;
					} else {
						headerHeight = document.querySelector(".header-container").offsetHeight;
					}
				}
				const $target = $(urlHash);
				const position = $target.offset().top - headerHeight;
				$('body,html').animate({scrollTop:position}, speed, 'swing');
			}, 500);
		}

		//クリックした時にスムーススクロールの処理
		$scroll.on('click', event => {
			// デフォルトの挙動を無効化
			event.preventDefault();

			if( document.querySelector(".l-gnav") ) {
				//1025px以上の端末
				if(window.innerWidth > 1024) {
					if( document.querySelector(".header").classList.contains("is-scrolled")) {
						headerHeight = document.querySelector(".l-gnav").offsetHeight;
					} else {
						headerHeight = document.querySelector(".header").offsetHeight - document.querySelector(".l-gnav").offsetHeight;
					}
				} else {
					headerHeight = document.querySelector(".header-container").offsetHeight;
					if(document.querySelector(".l-gnav").classList.contains("is-scrolled")) {
						headerHeight - document.querySelector(".header-title__label").offsetHeight;
					} else {
						headerHeight = headerHeight * 2 - document.querySelector(".header-title__label").offsetHeight;
					}
				}
			}

			const $this = $(event.currentTarget);
			// 移動先IDを取得
			const href = $this.attr('href');
			// 移動先を取得
			const $target = $(href);
			const position = $target.offset().top;
			$('body,html').animate(
				{ scrollTop:position - headerHeight } ,
				speed ,
				'swing',
				function() {
					const currentPosition = $target.offset().top;
					if(position != currentPosition ) {
						$('body,html').animate({ scrollTop:currentPosition - headerHeight} , speed, 'swing');
					}
				}
			);
		});
	}

	// リンク有効/無効切り替え
	function responsiveLink (){
		function link() {
			const $link = $('[data-link]');
			$link.on('click', event => {
				event.preventDefault();
				const $this = $(event.currentTarget);
				const type = $this.attr('data-link');
				const url = $this.attr('href');
				if (mqMd.matches) {
					if(type === 'md'){
						location.href = url;
					}
				} else {
					if(type === 'sm'){
						location.href = url;
					}
				}
			});
		}
		link();
		mqMd.addListener(link);
	}

	//リサイズ中のtransition停止
	function stopResponsiveTransition() {
		const $window = $(window);
		const body = $('body');
		const stopClass = 'is-stop-transition';
		let timer = null;
		$window.on('resize', event => {
			if (timer){
				clearTimeout(timer);
				timer = null;
			}else {
				body.addClass(stopClass);
			}
			timer = setTimeout(() => {
				body.removeClass(stopClass);
				timer = null;
			}, 100);
		});
	}

	//スライダー
	function slider(){
		//リンクブロック
		var swiper = undefined;
		var winW =  window.innerWidth;
		var recomend = '.js-slider-recomend';
		var swiperElement = $(recomend);
		var swiperWrapper = $('.swiper-wrapper');
		var swiperSlide = $('.swiper-slide');
		var options = {
			loop: false,
			speed: 1000,
			slidesPerView: 4,
			watchOverflow: true,
			navigation: {
				nextEl: '.swiper-button-next',
				prevEl: '.swiper-button-prev'
			}
		};
		function initSwiper() {
		  if(swiperElement){
			var screenWidth = window.innerWidth;
			if(screenWidth > breakpointMd - 1 && swiper == undefined) {
			  swiper = new Swiper(recomend, options);
		  } else if (screenWidth <= breakpointMd - 1 && swiper != undefined) {
			  swiper.destroy();
			  swiper = undefined;
			  for( var i=0;i<swiperWrapper.length; i++ ) {
				swiperWrapper[i].removeAttribute('style');
			  }
			  for( var i=0;i<swiperSlide.length; i++ ) {
				swiperSlide[i].removeAttribute('style');
			  }
			}
		  }
		}
		if($(recomend).length){
			initSwiper();
			window.addEventListener('resize',initSwiper);
		}

		//トップカルーセル
		const homeswiper = new Swiper ('.js-slider-home', {
			loop:true,
			centeredSlides: true,
			slidesPerView: 1,
			speed: 1000,
			autoplay: {
				delay: 5000,
				stopOnLastSlide: false,
				disableOnInteraction: false,
				reverseDirection: false
			},
			navigation: {
				nextEl: '.swiper-button-next',
				prevEl: '.swiper-button-prev'
			},
			pagination: {
				el: '.swiper-pagination',
				type: 'bullets',
				clickable: true
			}
		});

		//Careerのカルーセル
		const careerswiper = new Swiper ('.js-slider-career', {
			on: {
				init: function () {
					$(".swiper-container").css("opacity","1");
				},
			  },
			loop:true,
			// centeredSlides: true,
			speed: 1000,
			breakpoints: {
				767 : {
					slidesPerView: 1,
					spaceBetween :48
				}
			},
			slidesPerView: 3,
			spaceBetween : 48,
			navigation: {
				nextEl: '.swiper-button-next',
				prevEl: '.swiper-button-prev'
			},
			pagination: {
				el: '.swiper-pagination',
				type: 'bullets',
				clickable: true
			}
		});
		//Umami Recipesのカルーセル
		const umamiRecipes = new Swiper ('.ur-explore-carousel', {
			on: {
				init: function () {
					$(".swiper-container").css("opacity","1");
				},
			  },
			loop: true,
			// centeredSlides: true,
			speed: 1000,
			slidesPerView: 4,
			breakpoints: {
				767 : {
					slidesPerView: 2,
				}
			},
			navigation: {
				nextEl: '.swiper-button-next',
				prevEl: '.swiper-button-prev'
			},
			pagination: {
				el: '.swiper-pagination',
				type: 'bullets',
				clickable: true
			}
		});
	}

	/**
	 * Stories archive page
	 *
	*/
	function storiesArchiveLayout() {
		var windowWidth = getScreenSize();
		var storiesTagListHeight;
		var storiesAddPadding;
		if(windowWidth['width'] > 768 ) {
			storiesAddPadding = 32;
		} else {
			storiesAddPadding = 0;
		}
		$('.stories-entries .stories-entry__section__tags').each(function(){
			storiesTagListHeight = $(this).innerHeight();
			if($(this).parents(".stories-entry").hasClass("stories-entry-first")) {
				storiesTagListHeight = storiesTagListHeight + storiesAddPadding;
			}
			$(this).prev(".stories-entry__section__lead").css("padding-bottom",storiesTagListHeight);
		})
	}
	// ウィンドウの幅と高さを取得
	function getScreenSize() {
		const windowSize = [];
		windowSize['width'] = window.innerWidth;
		windowSize['height'] = window.innerHeight;
		return windowSize;
	}

	function footerAccordion() {
		$(".js-footer").on("click",function(){
			const thisClass = $(this).hasClass("is-active");
			const windowSize = getScreenSize();
			if(windowSize["width"] < 1025) {
				if(!thisClass) {
					$(this).next().slideDown();
					$(this).addClass("is-active");
				} else {
					$(this).next().slideUp();
					$(this).removeClass("is-active");
				}
			}
		});
	}
	function footerResponsive() {
		const windowSize = getScreenSize();
		const $footerJS = $(".js-footer");
		const $footerSubmenu = $(".footer__submenu");
		if(windowSize["width"] > 1024) {
			$footerSubmenu.css("display","");
			$footerJS.removeClass("is-active");
		}
	}
	/**
	 * Ajinomoto Group History page
	 *
	*/
	function ajiHistoryTab() {
		const $tab = $(".chron-hist-tab .p-navi-tab__list-link");
		$tab.on("click", event => {
			event.preventDefault();
			const $thistab = $(event.currentTarget);
			$tab.removeClass("is-current");
			$thistab.addClass("is-current");
			const tabData = $thistab.data("name");
			const $age = $(".chron-hist-age");
			$age.each(function(){
				var ageID = $(this).attr('id');
				if(ageID == tabData) {
					$(this).addClass(activeClass);
				} else {
					$(this).removeClass(activeClass);
				}
			});
		});
	}






const $videoModalBtns = document.querySelectorAll(".p-modal-video-open")
					  ? document.querySelectorAll(".p-modal-video-open")
					  : false;

if($videoModalBtns) {
	$videoModalBtns.forEach( $button => {
		$button.addEventListener("click" , (e) => {
			videoModal(e);
		});
	});
}

//モーダルの表示と動画の再生
const videoModal = (e) => {

	//クリックしたボタンの「data-modal」属性を取得
	const modalID = e.currentTarget.dataset.modal;

	//同じmodalIDの要素を取得
	const $videoModal = e.currentTarget.classList.contains("is-youtube")
					  ?	document.querySelector('.p-modal-video.is-youtube')
					  : document.querySelector('[data-video-modal="' + modalID + '"]');



	//モーダルの閉じるボタン
	//ddata-close-butto属性で取得
	const $modalClose = e.currentTarget.classList.contains("is-youtube")
					  ? document.querySelector(".p-modal-video__nav__close")
					  :	document.querySelector('[data-video-close="'+modalID+'"]');

	//モーダルを表示
	const windowHeight = window.innerHeight;
	$videoModal.classList.add("is-opened");
	$videoModal.style.height = `${windowHeight}px`;

	//動画の再生
	if( typeof videojs !== "undefined") {
		videojs.getPlayer(modalID).ready( function() {
			//プレイヤーのオブジェクトを取得
			const videoPlayer = this;
			 /*
			 * 動画初期化
			 */
			videoPlayer.muted(true); //ミュート
			videoPlayer.play(); //再生開始
			videoPlayer.controlBar.show();
			videoPlayer.bigPlayButton.show();

			var _resizeEvent;
			window.addEventListener('resize' , () => {
				clearTimeout(_resizeEvent);
				_resizeEvent = setTimeout( () => {
					console.log("resize");
					const windowHeight = window.innerHeight;
					$videoModal.style.height = `${windowHeight}px`;
				} , 100);
			});
			//モーダルを閉じる
			$modalClose.addEventListener( "click" , ( e ) => {
				videoPlayer.pause();
				$videoModal.classList.remove("is-opened");
				videoPlayer.muted(true);
			});
		});
	} else {
		let YTplayer = null; // 変数playerを用意
		function onYouTubeIframeAPIReady(videoId) { // APIが読み込まれて準備が整ったら実行される関数
			YTplayer = new YT.Player('player', { // YT.Playerオブジェクトを作成（'player'は動画の挿入先のid名）
				videoId: videoId,
				playerVars: {
					'autoplay': 1,
					'mute': 1,
					'loop': 1,
					'rel': 0
				},
			})
			$modalClose.addEventListener("click" , ()=> {
				YTplayer.destroy();
				$videoModal.classList.remove("is-opened");
			})
		}

		onYouTubeIframeAPIReady(modalID);
	}



}

})();
